import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose, withProps } from 'recompose';
import { Col, Row } from 'react-bootstrap';
import omitProps from '../../../utils/omitProps';
import queryMetaHandler from '../../../utils/queryMetaHandler';

const propTypes = exact({
  // eslint-disable-next-line react/no-unused-prop-types
  ticketId: PropTypes.number.isRequired,
  jobStatus: PropTypes.string.isRequired,
  ticketStatus: PropTypes.string.isRequired,
});


const TicketStatus = (props) => {
  const { ticketStatus, jobStatus } = props;
  return (
    <div>
      <Row>
        <Col md={6}>
          <h3>
            Job: {jobStatus}
          </h3>
        </Col>
        <Col md={6}>
          <h3 className="pull-right">
            Ticket: {ticketStatus}
          </h3>
        </Col>
      </Row>
    </div>
  );
};


TicketStatus.propTypes = propTypes;

export const Query = gql`
  query TicketView($ticketId: Int!) {
    ticket(ticket_id: $ticketId) {
      id
      state
      job {
        id
        state
      }
    }
  }
`;


const withData = graphql(Query, {
  options: { fetchPolicy: 'network-only' },
});


const mapDataToProps = withProps((props) => {
  const { data: { ticket } } = props;
  const ticketStatus = ticket.state;
  const jobStatus = ticket.job.state;
  return {
    ticketStatus,
    jobStatus,
  };
});


const enhance = compose(
  withData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);


export default enhance(TicketStatus);
